import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ProtectedRoute = ({ publicOnly = false }) => {
  const { accessToken, role, isLoggingOut } = useAuth();

  // PUBLIC ROUTES (login, signup, etc.)
  if (publicOnly) {
    if (accessToken) {
      if (role === "admin") return <Navigate to="/admin" replace />;
      switch (role) {
        case "freelancer":
          return <Navigate to="/home/freelancer-home" replace />;
        case "business":
          return <Navigate to="/home/business-home" replace />;
        default:
          return <Navigate to="/home" replace />;
      }
    }
    return <Outlet />;
  }

  // PRIVATE USER ROUTES
  // **NEW:** if user has no accessToken but is logging out, send to landing instead of login
  if (!accessToken) {
    if (isLoggingOut) return <Navigate to="/" replace />;
    return <Navigate to="/login" replace />;
  }

  // Block admins from user routes
  if (role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;